import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import MaterialTable from "material-table";
import { baseUrl } from '../../../config';
import axiosIntance from '../../../helper/axios';
import { clickColor, inArray } from '../../../library/util';
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import { checkAccess, FEATURES } from '../../../library/auth'

function ProductsInfo() {

  const history = useHistory();

  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedrowList, setSelectedRowList] = useState([]);
  const [cssCodesData, setcssCodesData] = useState([])
  const [message, setMessage] = useState('')

  if (!checkAccess(FEATURES.products_list)) {
    history.push('/')
  }
  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null) {
    history.push('/');
  }

  const handleSignOut = () => {
    console.log('logout')
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  const setRowBackground = (selectedRow) => {
    if (inArray(selectedRow.tableData.id, selectedrowList) == false) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }

  useEffect(() => {

    axiosIntance.get(baseUrl + '/reports/profitabilityDiagnosis/products', {}).then(response => {
      console.log('data')
      console.log(response.data.result)
      if (response.data.result.length > 0) {
        setcssCodesData(response.data.result);
      }
    }).catch(error => {
      setMessage('Something went wrong');
    });

    return () => {
      console.log('un subscribe')
    }
  }, [])

  return (
    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />

      <div className='errorMsg'>{message}</div>

      <section id="content-wrapper">
        <MaterialTable
          onRowClick={((evt, selectedRow) =>
            setRowBackground(selectedRow)
          )}

          columns={[
            { title: "SKU", field: "prime_sku" },
            { title: "Product Type", field: "product_type" },
            { title: "Unit Cost", field: "unit_cost" },
            { title: "Unit Cost Ecomm", field: "unit_cost_ecomm" },
            { title: "Dimensions", field: "dimensions" },
            { title: "Weight", field: "weight_oz" }
          ]}

          data={
            cssCodesData
          }

          title="Products"

          options={{
            actionsColumnIndex: -1,
            addRowPosition: "first",
            maxBodyHeight: '560px',
            paging: false,
            headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
            })
          }}
        />
      </section>

    </div>
  )
}

export default ProductsInfo
